import { isFlutterApp, getMobileAppMetadata } from '@ecs-uk/web-common-mobile-view-helpers';

export const ANALYTICS_PLATFORM_CHANNELS = {
  WEB: 'web',
  IOS_WEBVIEW: 'ios_webview',
  ANDROID_WEBVIEW: 'android_webview',
} as const;

type AnalyticsPlatformChannel = (typeof ANALYTICS_PLATFORM_CHANNELS)[keyof typeof ANALYTICS_PLATFORM_CHANNELS];

const METADATA_TIMEOUT_MS = 3000;

const getMobileAppMetadataWithTimeout = () =>
  Promise.race([
    getMobileAppMetadata(),
    new Promise<never>((_resolve, reject) => {
      setTimeout(() => reject(new Error('Timed out waiting for mobile app metadata')), METADATA_TIMEOUT_MS);
    }),
  ]);

export const getAnalyticsPlatformChannel = async (): Promise<AnalyticsPlatformChannel | null> => {
  try {
    const isMobileApp = isFlutterApp();

    if (!isMobileApp) {
      return ANALYTICS_PLATFORM_CHANNELS.WEB;
    }
    const metadata = await getMobileAppMetadataWithTimeout();

    switch (metadata.platform) {
      case 'iOS':
        return ANALYTICS_PLATFORM_CHANNELS.IOS_WEBVIEW;
      case 'android':
        return ANALYTICS_PLATFORM_CHANNELS.ANDROID_WEBVIEW;
      default:
        return null;
    }
  } catch {
    return null;
  }
};
